
(function (window, document, $, undefined) {
    // apply on doc ready
    $(document).ready(customizeCarousels);

    // add customizations to carousels
    function customizeCarousels() {

        // iterate over carousels
        var $carousels = $(".carousel");
        $carousels.each(function extendCarousel() {
            var $carousel = $(this);
            var $slides = $carousel.find('.carousel-item');

            // set initial style
            setStyle($carousel, $($slides[0]));

            // change style when sliding to next item
            this.addEventListener('slide.bs.carousel', function (e) {
                var $nextSlide = $($slides[e.to]);
                setStyle($carousel, $nextSlide);
            });
        });
    }

    // set/change the default style
    function setStyle($carousel, $slide) {
        switch ($slide.data('variant')) {
            case 'bright':
                $carousel.removeClass('carousel-dark');
                break;
            case 'dark':
                $carousel.addClass('carousel-dark');
                break;
        }
    }
})(window, document, jQuery);
